import React, { useCallback, useEffect, useMemo, useState } from 'react'
import NonlalinService from '../../../services/nonlalin/NonlalinService'
import UserService from '../../../services/user/UserService'
import PbUmkuService from '../../../services/pbumku/PbumkuService'
import { getCurrentDateFormatted, romanNum } from '../../../utilities/Utils'
import { Button, Modal, Spinner } from 'react-bootstrap'
import NonlalinDisposisi from '../../../utilities/nonlalin/NonlalinDisposisi'
import { AsyncPaginate } from 'react-select-async-paginate'
import SweetAlert from 'react-bootstrap-sweetalert'

const ModalSppNonLalin = ({ showAddPenugasan, handleCloseAddPenugasan, dataDisposisi, datappm, reloadList, isEdit }) => {
    const currentDate = new Date()
    const currentMonth = currentDate.getMonth() + 1
    const currentYear = currentDate.getFullYear()

    const [showConfirmPenugasan, setShowConfirmPenugasan] = useState(false)
    const handleCloseConfirmPenugasan = () => setShowConfirmPenugasan(false)
    const [showPenugasanSuccess, setShowPenugasanSuccess] = useState(false)
    const [showPenugasanFailed, setShowPenugasanFailed] = useState(false)
    const [rowPenugasan, setRowPenugasan] = useState(null)

    const [valuePejabatOpt, setValuePejabatOpt] = useState(null)
    const [valuePegawaiOpt, setValuePegawaiOpt] = useState(null)

    const [loadingSave, setLoadingSave] = useState(false)

    let nonLalinService = useMemo(() => new NonlalinService(), [])
    let userService = useMemo(() => new UserService(), [])
    let pbumkuService = useMemo(() => new PbUmkuService(), [])

    const fetchAllData = useCallback(async () => {
        if (!datappm?.nomorAju || !dataDisposisi?.idProses) {
            console.warn("datappm atau dataDisposisi belum tersedia");
            return;
        }

        try {
            const resPejabat = await userService.getPegawaiById(dataDisposisi.nipPejabat)
            setValuePejabatOpt(resPejabat.data)

            const resPetugas = await nonLalinService.listNonlalinPenugasanDetil(datappm.nomorAju, dataDisposisi.noTugas)
            const resPegawai = await userService.listPegawai(null, localStorage.getItem('kdUnit'), 0, 100)
            const optionPegawai = resPegawai.data.data

            const mappedSelected = resPetugas.data.map(item => {
                const found = optionPegawai.find(
                    opt => opt.nip === item.nipPetugas
                );

                if (!found) return null; // handle jika tidak ketemu

                return {
                    nip: found.nip,
                    nama: found.nama,
                    jabatan: found.jabatan,
                    unit: found.unit,
                    kdUnit: found.kdUnit,
                    status: found.status,
                    noReg: found.noReg,
                    pathTtdImg: found.pathTtdImg
                }
            }).filter(Boolean)
            setValuePegawaiOpt(mappedSelected)
        } catch (error) {

        }

    }, [nonLalinService, dataDisposisi, datappm, userService])

    useEffect(() => {
        let isMounted = true;
        if (!datappm) return;

        const loadData = async () => {
            try {
                await fetchAllData();
            } catch (e) {
                if (isMounted) console.error(e);
            }
        };

        loadData();

        return () => { isMounted = false; };
    }, [datappm, fetchAllData]);

    async function loadOptionPejabatTtd(search, loadedOption, { page = 1 }) {
        const response = await userService.listPegawai(search, localStorage.getItem('kdUnit'), page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }

    async function loadOptionPegawai(search, loadedOption, { page = 1 }) {
        const response = await userService.listPegawai(search, localStorage.getItem('kdUnit'), page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }

    const onChangePejabatOpt = e => {
        setValuePejabatOpt(e)
    }

    const onChangePegawaiOpt = e => {
        setValuePegawaiOpt(e)
        // console.log(e)
    }

    const SavePenugasan = (dataDisposisi) => {
        setShowConfirmPenugasan(true)
        setRowPenugasan(dataDisposisi)
    }

    const handleClickPenugasan = async () => {
        setLoadingSave(true)
        try {
            let idDispLap = ''
            let kodeStatus = ''
            let noSuratTugas = ''
            let jnsPenomoran = ''

            idDispLap = 4
            kodeStatus = '022'
            jnsPenomoran = 'NLL_SPPLAB'

            const respNomor = await pbumkuService.ambilNomorService(jnsPenomoran, datappm.kodeUpt, currentYear, localStorage.getItem('username'))
            noSuratTugas = respNomor.data.uraianPusat + '/' + datappm.kodeUpt + '/' + romanNum(currentMonth) + '/' + currentYear + '/' + respNomor.data.nomorUrut
            let jsonSpp = { ...rowPenugasan, noTugas: noSuratTugas, tglTugas: getCurrentDateFormatted(), nipPejabat: valuePejabatOpt.nip, nmPejabat: valuePejabatOpt.nama, createdBy: localStorage.getItem("userId"), createdAt: new Date() }
            const _resSpp = await nonLalinService.saveNonlalinPenugasan(jsonSpp)
            if (_resSpp.data.kode === '200') {
                valuePegawaiOpt.map(async (pegawai) => {
                    let jsonSppTugas = {
                        nomorAju: datappm.nomorAju,
                        noTugas: noSuratTugas,
                        nipPetugas: pegawai.nip,
                        namaPetugas: pegawai.nama
                    }
                    // console.log(jsonSppTugas)
                    await nonLalinService.saveNonlalinPenugasanDetil(jsonSppTugas)
                })

                if (idDispLap !== '') {
                    let jsonLap = { idDisposisi: idDispLap, nomorAju: datappm.nomorAju }
                    await nonLalinService.saveNonlalinPenugasan(jsonLap)
                    // let jsonBast = { idDisposisi: 3, nomorAju: datappm.nomorAju }
                    // await nonLalinService.saveNonlalinPenugasan(jsonBast)
                    // let jsonPnbp = { idDisposisi: 5, nomorAju: datappm.nomorAju }
                    // await nonLalinService.saveNonlalinPenugasan(jsonPnbp)

                    let dataPpm = { ...datappm, status: '025' }
                    await nonLalinService.saveNonlalinHeader(dataPpm)

                    let dataStatus = {
                        nomorAju: datappm.nomorAju,
                        kodeStatus: kodeStatus,
                        waktuStatus: new Date(),
                        createdBy: localStorage.getItem('username')
                    }
                    await nonLalinService.saveNonlalinStatus(JSON.stringify(dataStatus))
                    dataStatus = {
                        nomorAju: datappm.nomorAju,
                        kodeStatus: '025',
                        waktuStatus: new Date(),
                        createdBy: localStorage.getItem('username')
                    }
                    await nonLalinService.saveNonlalinStatus(JSON.stringify(dataStatus))
                }

                setShowPenugasanSuccess(true)
                setShowConfirmPenugasan(false)
            }
        } catch (error) {
            console.log(error)
            setShowPenugasanFailed(true)
        }
        setLoadingSave(false)
    }

    const handleClickPenugasanSuccess = () => {
        setShowPenugasanSuccess(false)
        // window.location.reload()
        reloadList(datappm.nomorAju)
    }

    const handleClickPenugasanFailed = () => {
        setShowPenugasanFailed(false)
    }

    return (
        <>
            <Modal show={showAddPenugasan}
                onHide={handleCloseAddPenugasan}
                backdrop='static'
                keyboard={false}
                size="xl"
                centered
            >
                <Modal.Header>
                    <h6><NonlalinDisposisi idDisposisi={dataDisposisi.idDisposisi} /></h6>
                </Modal.Header>
                <Modal.Body>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Nomor Aju</label>
                        <div className="col-sm-8">
                            <input type="text" className="col-sm-12 form-control-sm" name="nomor_aju" defaultValue={datappm.nomorAju} readOnly />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Pejabat Penandatangan</label>
                        <div className="col-sm-8">
                            <AsyncPaginate
                                loadOptions={loadOptionPejabatTtd}
                                value={valuePejabatOpt}
                                getOptionLabel={(option) => option.nip + ' - ' + option.nama}
                                getOptionValue={(option) => option.nip}
                                additional={{
                                    page: 1
                                }}
                                onChange={onChangePejabatOpt}
                            />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Petugas</label>
                        <div className="col-sm-8">
                            <AsyncPaginate
                                loadOptions={loadOptionPegawai}
                                value={valuePegawaiOpt}
                                getOptionLabel={(option) => option.nip + ' - ' + option.nama}
                                getOptionValue={(option) => option.nip}
                                additional={{
                                    page: 1
                                }}
                                onChange={onChangePegawaiOpt}
                                isMulti
                            />
                        </div>
                    </div>

                </Modal.Body>
                <Modal.Footer>
                    {isEdit && <Button variant="primary" size="sm" onClick={() => SavePenugasan(dataDisposisi)}>Simpan</Button>}{' '}
                    <Button variant="danger" size="sm" onClick={handleCloseAddPenugasan}>
                        Batal
                    </Button>
                </Modal.Footer>
            </Modal>
            {
                showConfirmPenugasan &&
                <SweetAlert
                    title="Proses Penugasan?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingSave ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Simpan...
                            </>
                        ) : (
                            "Proses"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickPenugasan}
                    onCancel={handleCloseConfirmPenugasan}
                    focusCancelBtn
                    reverseButtons={true}
                    btnSize="sm"
                    disabled={loadingSave}
                >
                    {loadingSave && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Proses data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showPenugasanSuccess &&
                <SweetAlert
                    title="Penugasan Berhasil"
                    success
                    onConfirm={handleClickPenugasanSuccess}
                    btnSize="sm"
                />
            }
            {
                showPenugasanFailed &&
                <SweetAlert
                    title="Penugasan Gagal"
                    danger
                    onConfirm={handleClickPenugasanFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
        </>
    )
}

export default ModalSppNonLalin